import { BRAZE_CONTENT_CARD } from '@/components/braze/enums';
import {
  ESCRIPT_ORDERS_ROUTE,
  ESCRIPT_REFILL_PHARMACY_ROUTE,
  ESCRIPT_REFILL_ROUTE,
  PATIENT_ORDERS_ROUTE,
  PATIENT_REFILL_PHARMACY_ROUTE,
  PATIENT_REFILL_ROUTE,
} from '@/routes/route-paths';
import { ImageContentCard } from '@montugroup/circuit-shared/components/braze/ImageContentCard';
import { useLocation } from 'react-router-dom';

export const BrazeImageCard = () => {
  const location = useLocation();

  switch (location.pathname) {
    case PATIENT_REFILL_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.PATIENT_REFILL} />;
    case ESCRIPT_REFILL_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.ESCRIPT_REFILL} />;
    case PATIENT_ORDERS_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.PATIENT_ORDERS} />;
    case ESCRIPT_ORDERS_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.ESCRIPT_ORDERS} />;
    case PATIENT_REFILL_PHARMACY_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.PATIENT_REFILL_PHARMACY} />;
    case ESCRIPT_REFILL_PHARMACY_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.ESCRIPT_REFILL_PHARMACY} />;
    default:
      break;
  }
};
